<style>
.fc-view-harness {
    max-height: calc(100vh - 230px) !important;
}
</style>

<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-menu :nudge-width="50" offset-y v-if="furnaces && furnaces.length > 1">
                                <v-toolbar-title slot="activator" class="d-inline-flex unselectable">
                                    <div>
                                        <span style="position: relative; bottom: -6px">{{
                                            $route.query.furnace_option ? `Furnace ${$route.query.furnace_option}` : "Select furnace"
                                        }}</span>
                                        <br />
                                        <span style="font-size: 14px; position: relative; top: -6px; font-weight: normal">{{ $t($route.meta.title) }}</span>
                                    </div>
                                    <v-icon dark>arrow_drop_down</v-icon>
                                </v-toolbar-title>

                                <v-list>
                                    <v-list-tile
                                        v-for="(item, index) in furnaces.filter((f) => f.short_code != ($route.query.furnace_option || ''))"
                                        :key="index"
                                        @click="setFurnace(item.short_code)"
                                    >
                                        <v-list-tile-title>{{ item.short_code }}</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                            <v-toolbar-title v-else class="d-inline-flex unselectable">
                                <div>
                                    <span style="position: relative; bottom: -6px">{{
                                        $route.query.furnace_option ? `Furnace ${$route.query.furnace_option}` : "No Active Furnace"
                                    }}</span>
                                    <br />
                                    <span style="font-size: 14px; position: relative; top: -6px; font-weight: normal">{{ $t($route.meta.title) }}</span>
                                </div>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-scan-barcode
                                v-if="hasPerm('batch.read')"
                                ref="scan_barcode"
                                scan-object="work_orders_batch"
                                header-text="Batch Lookup"
                                @scanned="routeFromBarcode($event)"
                                scan-label="i"
                                :global="true"
                            ></bc-scan-barcode>
                            <bc-btn-refresh permanent @invoke-method="dbRefreshPage()"></bc-btn-refresh>
                            <v-menu
                                v-model="search_menu"
                                offset-y
                                left
                                origin="right top"
                                content-class="notification-dropdown"
                                :close-on-content-click="false"
                                :close-on-click="false"
                                full-width
                                :loading="true"
                            >
                                <bc-tooltip slot="activator">
                                    <v-btn icon slot="activator" @click="search_menu = !search_menu">
                                        <v-icon>search</v-icon>
                                    </v-btn>
                                    {{ $t("lang.filter") }}
                                </bc-tooltip>
                                <div class="dropdown-content">
                                    <v-card>
                                        <app-section-loader :status="search_loader"></app-section-loader>
                                        <v-list>
                                            <v-list-tile class="mb-3">
                                                <v-text-field
                                                    ref="jig_tag_number"
                                                    v-focus="search_menu"
                                                    v-model="jig_tag_number_search"
                                                    placeholder="Jig Tag/Batch #"
                                                    :counter="showCounter(jig_tag_number_search, 14)"
                                                    prepend-icon="search"
                                                    single-line
                                                    class="mt-3"
                                                    @keyup.enter="searchJigTagNumber(jig_tag_number_search)"
                                                    @focus="$event.target.select()"
                                                    type="text"
                                                ></v-text-field>
                                            </v-list-tile>
                                        </v-list>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn flat @mouseup.left="search_menu = false">
                                                {{ $t("lang.cancel") }}
                                            </v-btn>
                                            <v-btn
                                                color="primary"
                                                flat
                                                @mouseup.left="dbSearchJigTagNumber(jig_tag_number_search)"
                                                :disabled="save_debounce || jig_tag_number_search == '' || jig_tag_number_search.length == 0"
                                            >
                                                {{ $t("lang.search") }}
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </div>
                            </v-menu>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : 'py-0'">
                    <v-layout row wrap>
                        <v-flex xs12 pt-3>
                            <bc-calendar
                                ref="calendar"
                                class="h-100"
                                :editable="false"
                                :furnace="filter.furnace_option"
                                event_url="work_orders/continuous/schedule_by_batch"
                                data_object="work_orders_batches"
                                mode="production"
                            ></bc-calendar>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

import app from "Main";

export default {
    data() {
        return {
            search_loader: false,
            jig_tag_number_search: "",
            search_menu: false,
            headers: [
                { text: this.$t("lang.customer"), sortable: false, width: "20%" },
                { text: this.$t("lang.part_number"), sortable: false, width: "15%" },
                { text: this.$t("lang.part_name"), sortable: false, width: "20%" },
                { text: this.$t("lang.qty"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.date_scheduled"), sortable: false, width: "15%", align: "center" },
                { text: this.$t("lang.current_station"), sortable: false, width: "15%" },
                { text: this.$t("lang.status"), sortable: false, width: "10%" },
            ],
            warehouse_headers: [
                { text: "", sortable: false, width: "5%" },
                { text: this.$t("lang.aged"), sortable: false, width: "10%", align: "center" },
                { text: this.$t("lang.customer"), sortable: false, width: "25%" },
                { text: this.$t("lang.part_number_short"), sortable: false, width: "15%" },
                { text: this.$t("lang.part_name"), sortable: false, width: "30%" },
                { text: this.$t("lang.warehouse_qty"), sortable: false, width: "15%", align: "center" },
                // { text: '', sortable: false, width: '15%' },
            ],
            slug_group: {},
            filtered_group: {},
            station_options: [],
            selected_wo: [],
            schedule_qty: [],
            grouped_stations: {},
            current_obj: null,
            filter: {
                furnace_option: null,
                start_date: null,
            },
            save_debounce: false,
            save_timeout: null,
            start_time: null,
            start_date: null,
            current_batch: null,
            current_warehouse: null,
            current_part: null,
            warehouse_dialog: false,
            schedule_dialog: false,
            confirm_schedule_dialog: false,
            approve_schedule_dialog: false,
            end_loader: false,
            current_approve: null,
            file_name: null,
            edit_schedule: {
                jig_tag_number: "",
                empty_box_location: "",
                lot_number: "",
                po_number: "",
            },
            temp_stations: ["setting", "pre_wash", "furnace", "post_wash", "temper"],
            printOptions: [
                { title: "documents", icon: "description", type: "print_process_sheet" },
                { title: "label", icon: "label", type: "print_4x6_label" },
            ],
            dbSearchJigTagNumber: _.debounce(this.searchJigTagNumber, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbRefreshPage: _.debounce(this.getRefresh, 1500, { maxWait: 1500, leading: true, trailing: false }),
            furnaces: [],
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        if (!to.query.furnace_option || !to.query.start_date) {
            store
                .dispatch("fetchMachines", {
                    url: "machines",
                    method: "get",
                    body: { line_id: 2, slug: "furnace" },
                    dataProperty: "machines",
                    commit: true,
                })
                .then((data) => {
                    if (data && data.machines && data.machines.length > 0) {
                        let start = null;
                        if (!to.query.start_date && !from.query.start_date) {
                            start =
                                new Date(
                                    new Date().toLocaleString("en-US", { timeZone: app.current_user ? app.current_user.user_time_zone : "America/New_York" })
                                ).setHours(0, 0, 0, 0) / 1000;
                        }
                        app.$router.push({
                            name: to.name,
                            query: {
                                furnace_option: to.query.furnace_option
                                    ? to.query.furnace_option
                                    : from.query.furnace_option
                                    ? from.query.furnace_option
                                    : data.machines[0].short_code,
                                start_date: to.query.start_date ? to.query.start_date : from.query.start_date ? from.query.start_date : start,
                            },
                        });
                        next((vm) => {
                            vm.furnaces = data.machines;
                        });
                    } else {
                        next((vm) => {
                            vm.$store.commit("toggleMainMenu", false);
                            vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                            vm.finishLoader();
                        });
                    }
                });
        } else {
            store
                .dispatch("fetchMachines", {
                    url: "machines",
                    method: "get",
                    body: { line_id: 2, slug: "furnace" },
                    dataProperty: "machines",
                    commit: true,
                })
                .then((data) => {
                    if (data && data.machines && data.machines.length > 0) {
                        next((vm) => {
                            vm.furnaces = data.machines;
                        });
                    }
                });

            next((vm) => {
                vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                vm.finishLoader();
            });
        }
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        let current_view = this.$refs.calendar.getView();
        if (
            to.query.furnace_option == from.query.furnace_option &&
            Object.keys(to.params).length == 0 &&
            to.query.start_date &&
            current_view.currentStart.getTime() / 1000 != +to.query.start_date
        ) {
            let cal_api = this.$refs.calendar.getApi();
            cal_api.gotoDate(+to.query.start_date * 1000);
        }
        this.setQuery(parsedQuery, this.filter, this.default_filter);
        this.finishLoader();
        next();
    },
    mounted() {},
    watch: {
        jig_tag_number_search: function (newVal, oldVal) {
            this.dbSearchJigTagNumber.cancel();
            this.save_debounce = false;
            clearTimeout(this.save_timeout);
        },
    },
    computed: {
        ...mapState({
            rules_machines: (state) => state.validation.rules_machines,
            rules_batches: (state) => state.validation.rules_batches,
            default_filter: (state) => state.work_orders.schedule_filter,
            page: (state) => state.work_orders.page,
            machines: (state) => state.machines.machines,
            production_lines: (state) => state.production.production_lines,
            work_orders_production: (state) => state.work_orders.work_orders_production,
            warehouse: (state) => state.work_orders.warehouse,
            schedule: (state) => state.work_orders.schedule,
        }),
        axiosParams() {
            let prep_filter = {};
            prep_filter = JSON.parse(JSON.stringify(this.filter));
            if (!this.filter.furnace_option) {
                prep_filter.furnace_option = "";
            }
            return this.prepareParams(prep_filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
        currApproveField() {
            return (field) => {
                return this.current_approve && field && this.current_approve[field] ? this.current_approve[field] : "";
            };
        },
        total_qty() {
            return _.sumBy(this.schedule_qty || [], (qty) => +qty);
        },
        total_batches() {
            let total = 0;
            if (this.current_part && !!(+this.total_qty / +this.current_part.batch_size)) {
                total = Math.ceil((+this.total_qty / +this.current_part.batch_size) * 1000) / 1000;
            }
            return Math.max(total, 0);
        },
        partial_batch() {
            if (!this.current_part || !this.total_qty) return 0;
            return Math.ceil((this.total_batches * 1000) % 1000) / 10;
        },
        allow_filter() {
            let diff_params =
                (this.axiosParams && Object.keys(this.axiosParams).length > 0 && JSON.stringify(this.axiosParams) != JSON.stringify(this.$route.query)) ||
                JSON.stringify(this.axiosParams) != JSON.stringify(this.$route.query) ||
                (!!this.filter.date_scheduled && !!this.$route.query.date_scheduled && this.$route.query.date_scheduled != this.filter.date_scheduled);
            return diff_params;
        },
    },
    methods: {
        openApproveDialog(item) {
            this.approve_schedule_dialog = true;
            this.current_approve = item;
        },
        openScheduleDialog(batch) {
            this.getDefaultSchedule(batch, false);
            this.current_batch = batch;
            this.schedule_dialog = true;
            this.edit_schedule.lot_number = "";
            this.edit_schedule.po_number = "";
            this.edit_schedule.jig_tag_number = "";
            this.edit_schedule.empty_box_location = "";
            this.start_date = this.current_day;
            this.start_time = this.current_time;
        },
        modifyBatch(batch = null) {
            if (batch) {
                let id = batch.batch_id;
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (this.validateForm("schedule_date")) {
                        let _batch_obj = this.edit_schedule;
                        _batch_obj.date_scheduled = `${this.start_date} ${this.start_time}`;
                        _batch_obj.part_station_id = this.station_options;
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchWorkOrder", {
                                pk: "batch_id",
                                id: id,
                                url: `work_orders/${batch.work_order_id}/batches/${id}`,
                                method: "patch",
                                stateProperty: "work_orders_batches",
                                dataProperty: "work_orders_batch",
                                mutate: true,
                                body: _batch_obj,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.schedule_dialog = false;
                                    this.$store.commit("validationOff");
                                }
                                this.$store.commit("toggleModalLoader", false);
                            });
                    }
                });
            }
        },
        getRefresh() {
            // this.startLoader();
            // this.end_loader = true;
            this.$refs.calendar.refreshEvents();
        },
        openProfile(order) {
            if (order && order.work_order_id && order.batch_id && order.date_scheduled) {
                this.$router.push({ name: "batch_profile", params: { work_order_id: order.work_order_id, batch_id: order.batch_id } });
            }
        },
        scheduleBatch() {
            // alert('schedule')
            if (this.validateForm("schedule")) {
                let batches = [];
                this.schedule.forEach((s, i) => {
                    // only send if a qty is entered
                    if (!!this.schedule_qty[i] && +this.schedule_qty[i] > 0) {
                        batches.push({
                            receiving_id: s.receiving_id,
                            batch_qty: this.schedule_qty[i],
                        });
                    }
                });

                let schedule_obj = {
                    company_id: this.current_part.company_id,
                    part_id: this.current_part.part_id,
                    part_station_id: this.station_options,
                    batches: batches,
                };
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: "work_orders",
                        method: "post",
                        stateProperty: "work_orders_batches",
                        mutate: true,
                        body: schedule_obj,
                    })
                    .then((data) => {
                        if (data && data.code == "200") {
                            if (+this.current_part.warehouse_qty - this.total_qty > 0) {
                                this.$store.commit("mutateWorkOrder", {
                                    property: "warehouse",
                                    method: "patch",
                                    id: data.work_orders_batches[0].part_id,
                                    pk: "part_id",
                                    with: {
                                        part_id: data.work_orders_batches[0].part_id,
                                        warehouse_qty: (+this.current_part.warehouse_qty - this.total_qty).toString(),
                                        batched_qty: (+this.current_part.batched_qty + this.total_qty).toString(),
                                    },
                                });
                            } else if (+this.current_part.warehouse_qty - this.total_qty == 0) {
                                this.$store.commit("mutateWorkOrder", {
                                    property: "warehouse",
                                    method: "delete",
                                    id: data.work_orders_batches.part_id,
                                    pk: "part_id",
                                });
                            }
                            this.warehouse_dialog = false;
                            this.confirm_schedule_dialog = false;
                            setTimeout(() => {
                                this.current_part = null;
                            }, 300);
                        }
                        this.$store.commit("toggleModalLoader", false);
                    });
            }
        },
        confirmSchedule() {
            if (this.validateForm("schedule")) {
                this.confirm_schedule_dialog = true;
            }
        },
        getWorkOrders(status = true) {
            if (status) this.startLoader();
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "work_orders/batches",
                    method: "get",
                    stateProperty: "work_orders_batches",
                    commit: true,
                    body: { ...JSON.parse(JSON.stringify(this.$route.query)), line_id: 2 },
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.work_order_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    if (status) this.finishLoader();
                    if (!status && this.end_loader) {
                        this.finishLoader(true);
                        this.end_loader = false;
                    }
                });
        },
        getArrayData() {
            if (this.production_lines == null) this.getProductionLines();
        },
        getProductionLines() {
            this.$store
                .dispatch("fetchProduction", {
                    url: "production_lines",
                    method: "get",
                    stateProperty: "production_lines",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                });
        },
        closeWarehouseDialog() {
            this.warehouse_dialog = false;
            this.current_part = null;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getWarehouse(status = true) {
            if (status) {
                this.$store.commit("toggleModalLoader", true);
                this.warehouse_dialog = true;
            }
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "warehouse?line_id=2",
                    method: "get",
                    stateProperty: "warehouse",
                    commit: true,
                })
                .then((data) => {
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        getDefaultSchedule(part = null, fill_batches = true) {
            if (part) {
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: `warehouse/by_part_id/${part.part_id}/2`,
                        method: "get",
                        stateProperty: "schedule",
                        dataProperty: "parts.warehouse",
                        commit: true,
                    })
                    .then((data) => {
                        if (typeof data != "undefined" && data.parts) {
                            this.current_part = data.parts;
                            this.current_warehouse = part;
                            this.grouped_stations = {};
                            this.station_options = [];
                            if (data.parts.parts_stations) {
                                this.grouped_stations = _.groupBy(data.parts.parts_stations, "sort_order");
                                let filter_group = JSON.parse(JSON.stringify(this.grouped_stations));
                                let slug_group = {};
                                for (const [key, value] of Object.entries(filter_group)) {
                                    // for (let j=0; j < value.length; j++) { if(value[j].slug == 'setting'){ value.splice(j,1) } }
                                    if (value.length == 0) {
                                        delete filter_group[key];
                                    } /* else if(value.length == 1) {
                                        this.station_options.push(value[0].part_station_id)
                                    } */ else {
                                        let group = {};
                                        if (fill_batches) {
                                            group = value.filter((e) => e.prime == "1");
                                            if (group && group.length > 0) {
                                                this.station_options.push(group[0].part_station_id);
                                            } else {
                                                this.station_options.push(value[0].part_station_id);
                                            }
                                        } else {
                                            if (value.length > 1) {
                                                let slug = value[0].slug;
                                                group = value.filter(
                                                    (e) =>
                                                        e.short_code == this.current_batch[`${slug}`] &&
                                                        e.pattern_number == this.current_batch[`${slug}_pattern`]
                                                )[0];
                                                this.station_options.push(group.part_station_id);
                                            } else {
                                                group = value[0];
                                                this.station_options.push(group.part_station_id);
                                            }
                                        }
                                        slug_group[group.slug] = value;
                                    }
                                }
                                this.slug_group = slug_group;
                                this.filtered_group = filter_group;
                            }
                            if (fill_batches && data.parts.warehouse) {
                                this.schedule_qty = Array(data.parts.warehouse.length).fill("");
                            }
                            // console.log(+part.warehouse_qty, +data.parts.warehouse_qty, '!=', +part.warehouse_qty != +data.parts.warehouse_qty)
                            if (fill_batches && +part.warehouse_qty != +data.parts.warehouse_qty) {
                                if (+data.parts.warehouse_qty == 0) {
                                    this.$store.commit("mutateWorkOrder", {
                                        property: "warehouse",
                                        method: "delete",
                                        id: data.parts.part_id,
                                        pk: "part_id",
                                    });
                                } else {
                                    this.$store.commit("mutateWorkOrder", {
                                        property: "warehouse",
                                        method: "patch",
                                        id: data.parts.part_id,
                                        pk: "part_id",
                                        with: {
                                            batched_qty: data.parts.batched_qty,
                                            warehouse_qty: data.parts.warehouse_qty,
                                            received_qty: data.parts.received_qty,
                                        },
                                    });
                                }
                            }
                            // auto fill batches
                            if (fill_batches && +data.parts.warehouse_qty > 0 && data.parts.batch_size) {
                                let curr_index = 0;
                                let curr_warehouses = this.schedule.map((a) => a.warehouse_qty);
                                let batch_size = +data.parts.batch_size;
                                let batches_needed = Math.floor(+data.parts.warehouse_qty / batch_size);

                                for (let x = 0; x < batches_needed; x++) {
                                    let skip = false;
                                    let current_batch = 0;
                                    for (let k = 0; k < curr_warehouses.length && !skip && current_batch < batch_size; k++) {
                                        if (curr_warehouses[k] > 0) {
                                            let w = curr_warehouses[k];
                                            if (this.schedule_qty[curr_index] == "") this.schedule_qty[curr_index] = 0;
                                            if (current_batch + +w <= batch_size) {
                                                this.schedule_qty[curr_index] += +w;
                                                curr_warehouses[k] = 0;
                                                current_batch += +w;
                                                if (this.schedule_qty[curr_index] == batch_size) {
                                                    skip = true;
                                                }
                                                curr_index++;
                                            } else {
                                                let num_to_pull = batch_size - current_batch;
                                                current_batch += +num_to_pull;
                                                this.schedule_qty[curr_index] = this.schedule_qty[curr_index] + num_to_pull;
                                                curr_warehouses[k] = +w - num_to_pull;
                                                if (w == 0) curr_index++;
                                                skip = true;
                                            }
                                        }
                                    }
                                }
                                this.schedule_qty = this.schedule_qty.map(String);
                            } else {
                                this.current_part = null;
                                this.$store.commit("toggleModalLoader", false);
                            }
                            // data.parts.warehouse.forEach(w => { console.log(w) this.$store.commit('mutateWorkOrder', { property: 'schedule', with: w, method: 'post' }) })
                        }
                    })
                    .finally(() => {
                        this.$store.commit("validationOn");
                        this.$store.commit("toggleModalLoader", false);
                    });
            }
        },
        approveBatch() {
            if (this.currApproveField("batch_id")) {
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchWorkOrder", {
                        pk: "batch_id",
                        id: this.currApproveField("batch_id"),
                        url: `work_orders/${this.currApproveField("work_order_id")}/batches/${this.currApproveField("batch_id")}/approve`,
                        method: "patch",
                    })
                    .then((data) => {
                        if (data && data.code == "200") {
                            this.approve_schedule_dialog = false;
                            this.$store.commit("mutateWorkOrder", {
                                property: "work_orders_batches",
                                method: "patch",
                                id: data.work_orders_batch_approval.batch_id,
                                pk: "batch_id",
                                with: {
                                    approved_for_production: "1",
                                },
                            });
                        }
                        this.$store.commit("toggleModalLoader", false);
                    });
            }
        },
        setFurnace(value) {
            this.filter.furnace_option = value;
            this.filterTool(this.axiosParams, false);
        },
        routeFromBarcode(barcode) {
            this.$router.push({ name: "batch_profile", params: { work_order_id: barcode.work_order_id, batch_id: barcode.batch_id } });
        },
        searchJigTagNumber(jig_tag) {
            if (jig_tag) {
                this.save_debounce = true;
                this.save_timeout = setTimeout(() => {
                    this.save_debounce = false;
                }, 1500);
                this.search_loader = true;
                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: `work_orders/batches`,
                        method: "get",
                        body: {
                            jig_tag_number: jig_tag,
                        },
                    })
                    .then((data) => {
                        if (data && (data.work_orders_batches || []).length > 0) {
                            let batch = data.work_orders_batches[0];
                            this.$router.push({ name: "batch_profile", params: { work_order_id: batch.work_order_id, batch_id: batch.batch_id } });
                        } else {
                            this.createAlert("error", "error_jig_tag_number");
                            this.search_loader = false;
                            this.$refs.jig_tag_number.focus();
                        }
                    });
            }
        },
    },
};
</script>
